{
  "live": {
    "listening": "Listening for events",
    "lastEvent": "Last event {{age}}",
    "paused": "Paused",
    "interrupted": "Updates interrupted",
    "updated": "Updated {{age}}",
    "pause": "Pause updates",
    "resume": "Resume updates",
    "refresh": "Refresh"
  },
  "loading": "Reading memory in your authorized scope…",
  "error": {
    "title": "Overview unavailable",
    "text": "The memory service did not return the overview."
  },
  "today": {
    "title": "Today · UTC",
    "collected": "Documents collected",
    "retrieved": "Records retrieved",
    "proposed": "Lessons proposed",
    "approved": "Lessons approved",
    "note": "Events since midnight UTC",
    "action": "Open"
  },
  "summary": {
    "title": "Summary",
    "empty": "Memory has nothing to work with yet. Once an operator connects a source, cited answers about your services appear after the first collection.",
    "emptyOperator": "Memory has nothing to work with yet. Connect a source and memory answers questions about your services, with citations, before your first investigation.",
    "memory": "Memory",
    "inDays": "In {{count}} day, memory",
    "inDays_plural": "In {{count}} days, memory",
    "collected": "collected from {{count}} source",
    "collected_plural": "collected from {{count}} sources",
    "and": " and ",
    "answered": "has cited answers to {{cited}} of {{total}} starter questions across {{count}} service scope",
    "answered_plural": "has cited answers to {{cited}} of {{total}} starter questions across {{count}} service scopes",
    "approved": "Reviewers approved {{count}} lesson.",
    "approved_plural": "Reviewers approved {{count}} lessons.",
    "investigations": "Agents captured {{count}} investigation.",
    "investigations_plural": "Agents captured {{count}} investigations.",
    "waiting": "{{count}} proposed lesson is waiting for a reviewer.",
    "waiting_plural": "{{count}} proposed lessons are waiting for a reviewer.",
    "retrieved": "Agents retrieved those lessons {{count}} time in {{days}} days.",
    "retrieved_plural": "Agents retrieved those lessons {{count}} times in {{days}} days.",
    "retrievedHelpful": "Agents retrieved those lessons {{count}} time and marked them helpful {{helpful}} times in {{days}} days.",
    "retrievedHelpful_plural": "Agents retrieved those lessons {{count}} times and marked them helpful {{helpful}} times in {{days}} days.",
    "withdrawn": "{{count}} lesson is out of use.",
    "withdrawn_plural": "{{count}} lessons are out of use.",
    "nothingVisible": "No overview sections are available in your authorized scope."
  },
  "map": {
    "title": "Memory, live",
    "note": "Where memory comes from, what it knows about each service, and which agents use it.",
    "ariaLabel": "Memory connections",
    "columns": {
      "source": "Sources",
      "service": "Memory by service",
      "review": "Review",
      "agent": "Agents"
    },
    "legend": {
      "observed": "Observed data",
      "reviewed": "Reviewed lesson",
      "waiting": "Waiting on a person",
      "blocked": "Collection stopped"
    },
    "cited": "{{cited}}/{{total}} cited",
    "lessons": "{{count}} lesson",
    "lessons_plural": "{{count}} lessons",
    "waiting": "{{count}} waiting",
    "retrievals": "{{count}} retrieval",
    "retrievals_plural": "{{count}} retrievals",
    "blocked": "Collection stopped",
    "mock": "mock",
    "empty": "Connect a source and the map fills in after the first collection.",
    "connect": "Connect a source",
    "ghost": {
      "source": "Sources appear once connected",
      "service": "Services appear after the first collection",
      "review": "Proposals wait here for a person",
      "agent": "Agents appear after their first retrieval"
    },
    "openHint": "Open the records behind this node.",
    "blockedHint": "An operator can check this source."
  },
  "loop": {
    "title": "The memory loop",
    "note": "Evidence becomes reusable knowledge through a person’s review.",
    "steps": {
      "connect": "Connect",
      "answer": "Answer",
      "investigate": "Investigate",
      "review": "Review",
      "reuse": "Reuse",
      "revise": "Revise"
    },
    "status": {
      "done": "Done",
      "next": "Next step",
      "notYet": "Not yet",
      "attention": "Needs attention",
      "waiting": "Waiting on a reviewer",
      "locked": "Auditors only"
    },
    "connect": {
      "unit": "source collected",
      "unit_plural": "sources collected",
      "collected": "Evidence collected into the scopes you can read.",
      "empty": "Kubernetes, GitHub, Datadog, PagerDuty and AWS work today. Your agents need no changes.",
      "blocked": "{{count}} source stopped collecting. An operator can check collection.",
      "blocked_plural": "{{count}} sources stopped collecting. An operator can check collection.",
      "blockedOperator": "{{count}} source stopped collecting. Open Sources to check it.",
      "blockedOperator_plural": "{{count}} sources stopped collecting. Open Sources to check them.",
      "blockedHealth": "{{count}} source stopped collecting. System health has its failed runs and retries.",
      "blockedHealth_plural": "{{count}} sources stopped collecting. System health has their failed runs and retries.",
      "openSources": "Open sources",
      "connect": "Connect a source",
      "openHealth": "Open system health",
      "openFeeds": "Open evidence"
    },
    "answer": {
      "unit": "of {{total}} answers cited",
      "scopes": "Across {{count}} service scope. See the table below for each answer’s source.",
      "scopes_plural": "Across {{count}} service scopes. See the table below for each answer’s source.",
      "empty": "Appears after the first collection.",
      "action": "See answers"
    },
    "investigate": {
      "unit": "investigation captured",
      "unit_plural": "investigations captured",
      "empty": "Capture one from Codex, Claude Code or Cursor.",
      "action": "Open investigations"
    },
    "review": {
      "approved": "lesson approved",
      "approved_plural": "lessons approved",
      "waitingUnit": "proposed lesson waiting",
      "waitingUnit_plural": "proposed lessons waiting",
      "waiting": "{{count}} proposed lesson waits for a reviewer.",
      "waiting_plural": "{{count}} proposed lessons wait for a reviewer.",
      "empty": "A person approves each lesson before agents reuse it.",
      "openQueue": "Open review queue",
      "openLessons": "Open lessons"
    },
    "reuse": {
      "unit": "retrievals in {{days}} days",
      "during": "Last retrieved during {{title}}.",
      "empty": "How often agents pull an approved lesson. A retrieval is not an outcome.",
      "action": "Open used lessons"
    },
    "revise": {
      "unit": "lesson withdrawn",
      "unit_plural": "lessons withdrawn",
      "note": "Lessons taken out of use when their evidence changes.",
      "locked": "Withdrawn lessons are visible to auditors.",
      "action": "Open withdrawn"
    }
  },
  "answers": {
    "title": "Answers by service",
    "note": "Seven starter questions per service, with the source behind each answer.",
    "truncated": "Showing a bounded set of service scopes. Not every authorized scope is covered here.",
    "empty": "No starter answers yet. They appear after the first collection.",
    "report": "Report",
    "cited": "Cited",
    "categories": {
      "owner": "Owner",
      "dependencies": "Dependencies",
      "runbook": "Runbook",
      "incidents": "Incidents",
      "runtime": "Runtime",
      "health": "Health",
      "deploys": "Deploys"
    },
    "short": {
      "owner": "Owner",
      "dependencies": "Deps",
      "runbook": "Book",
      "incidents": "Inc.",
      "runtime": "Run",
      "health": "Health",
      "deploys": "Ship"
    },
    "states": {
      "cited": "Cited",
      "stale": "Stale",
      "missing": "No answer"
    },
    "noAnswer": "No answer yet.",
    "pathMissing": "Path not recorded",
    "revisionMissing": "Revision not recorded",
    "openEvidence": "Open evidence",
    "showCitations": "Show citations for {{scope}}",
    "readyNote": "Ready means every answer cites a current source, not that the answers are verified."
  },
  "lesson": {
    "title": "Latest reviewed lesson",
    "badge": "Reviewed knowledge",
    "empty": "No approved lessons yet. A lesson shows up here after a person approves it, with the evidence it came from.",
    "emptyWaiting": "No approved lessons yet. A proposed lesson is waiting for a reviewer.",
    "openQueue": "Open review queue",
    "applies": "Applies when",
    "formation": "How it formed",
    "steps": {
      "sources": "Sources",
      "excerpts": "Evidence",
      "investigation": "Investigation",
      "human_review": "Human review",
      "lesson": "Reviewed lesson"
    },
    "excerpts": "{{count}} evidence record",
    "excerpts_plural": "{{count}} evidence records",
    "version": "Version {{version}}",
    "usage": "Retrieved {{count}} time in 30 days",
    "usage_plural": "Retrieved {{count}} times in 30 days",
    "helpful": "{{count}} marked helpful",
    "usageMissing": "Retrieval usage not recorded",
    "open": "Open lesson",
    "evidence": "See its evidence"
  },
  "reuse": {
    "title": "Agent reuse",
    "note": "Retrievals of approved lessons in the last {{days}} days.",
    "feedback": "Feedback from agents",
    "feedbackKinds": {
      "helpful": "Helpful",
      "not_helpful": "Not helpful",
      "wrong": "Wrong",
      "outdated": "Outdated"
    },
    "noFeedback": "No feedback yet.",
    "agents": "By agent",
    "noAgents": "No agent has retrieved a lesson yet.",
    "empty": "No agent has retrieved a lesson yet. Retrievals and agent feedback show up here once agents start using approved lessons.",
    "caveat": "A retrieval is not an outcome.",
    "open": "Open used lessons"
  },
  "activity": {
    "title": "Recent activity",
    "note": "Recorded events from your authorized scope.",
    "empty": "No recorded activity in this scope yet.",
    "events": "{{count}} events",
    "during": "During {{title}}",
    "types": {
      "investigated": "Captured an investigation",
      "collected": "Collected source data",
      "retrieved": "Retrieved memory",
      "proposed": "Proposed a lesson",
      "approved": "Approved a lesson",
      "withdrawn": "Took a lesson out of use",
      "unknown": "Recorded activity"
    }
  },
  "definitions": {
    "title": "How we count",
    "scope": "Counts come from your authorized scope. Not measured yet: time saved and incident outcomes.",
    "items": {
      "sources": {
        "term": "Sources",
        "text": "Providers with collected source revisions in the scopes you can read. A declared local mock is labeled."
      },
      "questions": {
        "term": "Starter questions",
        "text": "Seven per service scope: owner, dependencies, runbook, incidents, runtime, health and deploys. A question counts when an authorized source answers it with a citation."
      },
      "investigations": {
        "term": "Investigations",
        "text": "Investigations an agent captured, with their events."
      },
      "lessons": {
        "term": "Approved lessons",
        "text": "Lessons a person reviewed and published."
      },
      "retrievals": {
        "term": "Retrievals",
        "text": "Times an agent’s search returned an approved lesson. A retrieval is not an outcome."
      },
      "withdrawn": {
        "term": "Withdrawn",
        "text": "Lessons taken out of use. Evidence changes can cause withdrawal; the count alone does not establish a cause."
      }
    },
    "streaks": "A moving dot on the map is one recorded event on a known connection. A quiet map means nothing happened."
  }
}
